/**
 * Import Shave from package.json
 */
import shave from 'shave';

/**
 * Import eventThrottle
 */
import { eventThrottle } from '../../../utility';

/**
 * Set variables that will be used in the truncateExcerpts() function
 */
const excerpts = document.querySelectorAll('.custom-post-index__excerpt');
const excerptsArray = [...excerpts];

/**
 * Function Declaration
 */
function truncateExcerpts() {
  excerptsArray.forEach((excerpt) => {
    // Get the height of the container that contains the title and the excerpt (set in CSS)
    const contentHeight = excerpt.parentElement.offsetHeight;
    // Get the height of just the title
    const titleHeight = excerpt.previousElementSibling.offsetHeight;
    // Calculate the total available height for the excerpt
    const availableHeight = contentHeight - titleHeight;
    shave(excerpt, availableHeight);
  });
}

// Call truncateExcerpts function
truncateExcerpts();

/**
 * Truncate Post Excerpts again and make them visible after 1 second in case that the JS loaded before the CSS
 */
setTimeout(() => {
  // Truncate excerpts
  truncateExcerpts();
  // Make excerpts visible
  excerptsArray.forEach((excerpt) => {
    excerpt.style.visibility = 'visible';
  });
}, 1000);

/**
 * Truncate Post Excerpts when browser window is resized
 */
window.addEventListener('resize', eventThrottle(() => truncateExcerpts(), 200));